import { Keys } from './constants';
import { WebSessionStorage } from './web-session-storage';

export default WebSessionStorage;

export { Keys as SessionStorageKeys };
